// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const InfoDiscIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 22a10 10 0 1110-10 10 10 0 01-10 10zm0-18a8 8 0 108 8 8 8 0 00-8-8z"/><path d="M12 17a1 1 0 01-1-1v-4a1 1 0 012 0v4a1 1 0 01-1 1zm0-8a1 1 0 01-.92-1.38.9.9 0 01.54-.54.93.93 0 01.56-.08.6.6 0 01.19.06.76.76 0 01.18.09l.15.12a1 1 0 01.21.33 1 1 0 01-.21 1.09 1.15 1.15 0 01-.33.21A1 1 0 0112 9z"/></svg>'} />;

InfoDiscIcon.displayName = 'InfoDiscIcon';

export default InfoDiscIcon;
